import React from 'react';

//Estilos base:
let oneLineText = { textOverflow: "ellipsis", overflow: "hidden", whiteSpace: "nowrap", marginBottom: 0, width: "100%" };

let RadioButton = (props) => {
    return (
        <div className="form-check-radio">
            <label className="form-check-label" style={{ ...oneLineText }}>
                <input type="radio" className="form-check-input" readOnly checked={props.checked} data-id={props.id}/>
                <span className="form-check-sign" onClick={(e) => { props.onClick(props.downloadSource, e); }} />
                <span className="noselect" dangerouslySetInnerHTML={{ __html: props.label }} />
            </label>
        </div>
    );
}

export default RadioButton;